import {Middleware, isRejected} from '@reduxjs/toolkit'
import {PanoramaClientForComponent} from '@wix/yoshi-flow-editor/panorama'

export const createErrorLoggerMiddleware = ({
  errorMonitor,
}: {
  errorMonitor: PanoramaClientForComponent['errorMonitor']
}): Middleware => {
  return () => next => action => {
    if (isRejected(action)) {
      errorMonitor().reportError(new Error(`${action.type}: ${action.payload.message}`), {
        context: {
          requestId: action.payload.requestId,
          stack: action.payload.stack,
          tags: {
            reporter: 'redux-middleware',
          },
        },
      })
    }

    if (action.type.endsWith('_FAILURE')) {
      errorMonitor().reportError(action.error, {
        context: {
          tags: {
            reporter: 'redux-middleware',
          },
        },
      })
    }

    return next(action)
  }
}
